// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-chart-settings__content {
  width: 680px;
}
.wizard-chart-settings__settings > * {
  margin-bottom: 30px;
  display: flex;
  align-items: flex-start;
}
.wizard-chart-settings__widget-size {
  align-items: center;
}
.wizard-chart-settings__settings > div:last-child {
  margin-bottom: 0;
}
.wizard-chart-settings__settings .setting-navigator {
  height: auto;
}
.wizard-chart-settings__loader {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.wizard-chart-settings .dl-field-wrapper {
  width: auto;
  height: 26px;
}
.wizard-chart-settings__tooltip {
  display: inline-block;
}
.wizard-chart-settings__label {
  display: inline-block;
  width: 125px;
  margin-right: 16px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/Settings/Settings.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR;AAGI;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;AADR;AAII;EACI,mBAAA;AAFR;AAKI;EACI,gBAAA;AAHR;AAMI;EACI,YAAA;AAJR;AAOI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AALR;AAQI;EACI,WAAA;EACA,YAAA;AANR;AASI;EACI,qBAAA;AAPR;AAUI;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;AARR","sourcesContent":[".wizard-chart-settings__content {\n  width: 680px;\n}\n.wizard-chart-settings__settings > * {\n  margin-bottom: 30px;\n  display: flex;\n  align-items: flex-start;\n}\n.wizard-chart-settings__widget-size {\n  align-items: center;\n}\n.wizard-chart-settings__settings > div:last-child {\n  margin-bottom: 0;\n}\n.wizard-chart-settings__settings .setting-navigator {\n  height: auto;\n}\n.wizard-chart-settings__loader {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n.wizard-chart-settings .dl-field-wrapper {\n  width: auto;\n  height: 26px;\n}\n.wizard-chart-settings__tooltip {\n  display: inline-block;\n}\n.wizard-chart-settings__label {\n  display: inline-block;\n  width: 125px;\n  margin-right: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
